// 本次展示使用提供的设备资料；状态为资料记录值，不代表实时通信状态。
export const smokeBuilding = {
  id: 'baihedong-apartment',
  name: '白鹤洞老年公寓',
  sourceName: '白鹤洞(老年公寓)',
  address: '鹤洞路168号',
  unitName: '广钢金业展厅',
  // 楼宇定位使用提供的 BD-09 坐标，在地图展示入口转换，房间共用楼宇锚点。
  lng: 113.253570,
  lat: 23.079911,
  coordinateSystem: 'BD09'
};

// 本地标识仅供点位选择，不作为物联网平台设备 ID 或后台业务主键。
const apartmentDevices = [
  {
    id: '86099-60825-59236',
    buildingId: smokeBuilding.id,
    room: '805',
    floor: '8',
    location: '鹤洞路168号805房',
    name: '无线烟感',
    type: '感烟探测器-无线',
    manufacturer: '千宝通通无线烟感',
    system: '火灾自动报警系统',
    zone: '86099',
    loop: '60825',
    position: '59236',
    status: '正常',
    statusChangedAt: null,
    platformDeviceId: null,
    cameraId: null,
    contacts: [
      { role: '屋主', name: '何子俊', phone: '15920543454' },
      { role: '管理员', name: '张志权', phone: '13560028888' }
    ]
  },
  {
    id: '86099-60823-95284',
    buildingId: smokeBuilding.id,
    room: '810',
    floor: '8',
    location: '鹤洞路168号810房',
    name: '无线烟感',
    type: '感烟探测器-无线',
    manufacturer: '千宝通通无线烟感',
    system: '火灾自动报警系统',
    zone: '86099',
    loop: '60823',
    position: '95284',
    status: '正常',
    statusChangedAt: null,
    platformDeviceId: null,
    cameraId: null,
    contacts: [
      { role: '屋主', name: '郭俊文', phone: '13226607882' },
      { role: '管理员', name: '梁礼明', phone: '13760634286' }
    ]
  }
];

// 新增资料暂按高德 GCJ02 来源登记，原始坐标不改写；来源仍需现场参考点确认。
// 平西三巷记录的纬度明显偏离其余点位，保留资料但暂不参与地图展示。
const streetDevices = [
  {
    id: 'smoke-CA0A027PDE1E54D',
    serialNumber: 'CA0A027PDE1E54D',
    imei: '864501084026907',
    community: '金道社区',
    room: '402',
    name: '广州市荔湾区白鹤洞街道金道社区金通街16号402房大厅',
    location: '广州市荔湾区白鹤洞街道金道社区金通街16号402房大厅',
    place: '白鹤洞街道金道社区金通街16号402房',
    type: '感烟火灾探测器',
    model: 'DH-HY-SA1GA-A',
    connection: 'MQTT直连（烟感）',
    status: '正常',
    onlineStatus: '在线',
    battery: '100.0',
    signal: '弱',
    arming: '布防',
    firstOnlineAt: '2026-07-16 09:48:19',
    lastOnlineAt: '2026-09-16 18:21:51',
    installedAt: '2026-07-16 09:47:15',
    lng: 113.24316002608913,
    lat: 23.07890061741108,
    coordinateSystem: 'GCJ02',
    locationPending: false,
    contacts: [
      {
        role: '场所联系人',
        name: '谭生',
        phone: '13535474628'
      },
      {
        role: '管理员',
        name: '白鹤洞街道',
        phone: '13560304386'
      }
    ]
  },
  {
    id: 'smoke-CB09730PDEA3C9C',
    serialNumber: 'CB09730PDEA3C9C',
    imei: '865176080515713',
    community: '金道社区',
    room: '102',
    name: '广州市荔湾区白鹤洞街道金道社区金通街18号102房大厅',
    location: '广州市荔湾区白鹤洞街道金道社区金通街18号102房',
    place: '白鹤洞街道金道社区金通街18号102房',
    type: '感烟火灾探测器',
    model: 'DH-HY-SA1GA-A',
    connection: 'MQTT直连（烟感）',
    status: '正常',
    onlineStatus: '在线',
    battery: '100.0',
    signal: '弱',
    arming: '布防',
    firstOnlineAt: '2026-07-16 09:36:50',
    lastOnlineAt: '2026-09-17 02:57:05',
    installedAt: '2026-07-16 09:34:16',
    lng: 113.2411325321994,
    lat: 23.077829329838433,
    coordinateSystem: 'GCJ02',
    locationPending: false,
    contacts: [
      {
        role: '场所联系人',
        name: '何志平',
        phone: '13070285528'
      },
      {
        role: '管理员',
        name: '白鹤洞街道',
        phone: '13560304386'
      }
    ]
  },
  {
    id: 'smoke-CB09730PDEA76AC',
    serialNumber: 'CB09730PDEA76AC',
    imei: '865176080902606',
    community: '鹤洞社区',
    room: '703',
    name: '广州市荔湾区白鹤洞街道鹤洞社区鹤盛路285号703房大厅',
    location: '广州市荔湾区白鹤洞街道鹤洞社区鹤盛路285号703房大厅',
    place: '白鹤洞街道鹤洞社区鹤盛路285号703房',
    type: '感烟火灾探测器',
    model: 'DH-HY-SA1GA-A',
    connection: 'MQTT直连（烟感）',
    status: '正常',
    onlineStatus: '在线',
    battery: '100.0',
    signal: '强',
    arming: '布防',
    firstOnlineAt: '2026-07-15 11:16:04',
    lastOnlineAt: '2026-09-17 07:24:02',
    installedAt: '2026-07-15 11:14:00',
    lng: 113.25229226758711,
    lat: 23.080583034770374,
    coordinateSystem: 'GCJ02',
    locationPending: false,
    // 展厅展示位置向西约50米、向南约200米，保留原始安装坐标。
    displayPosition: { lng: 113.25179226758711, lat: 23.078777034770374, coordinateSystem: 'GCJ02' },
    contacts: [
      {
        role: '场所联系人',
        name: '曾玉屏',
        phone: '18312050042'
      },
      {
        role: '管理员',
        name: '白鹤洞街道',
        phone: '13560304386'
      }
    ]
  },
  {
    id: 'smoke-CB09730PDEA07AC',
    serialNumber: 'CB09730PDEA07AC',
    imei: '865176080766373',
    community: '山顶社区',
    room: '501',
    name: '广州市荔湾区白鹤洞街道山顶社区鹤洞路三巷78号501房',
    location: '广州市荔湾区白鹤洞街道山顶社区鹤洞路三巷78号501房',
    place: '白鹤洞街道山顶社区鹤洞路三巷78号501房',
    type: '感烟火灾探测器',
    model: 'DH-HY-SA1GA-A',
    connection: 'MQTT直连（烟感）',
    status: '正常',
    onlineStatus: '在线',
    battery: '100.0',
    signal: '弱',
    arming: '布防',
    firstOnlineAt: '2026-07-13 16:23:03',
    lastOnlineAt: '2026-09-17 10:29:39',
    installedAt: '2026-07-13 16:21:02',
    lng: 113.24940916508822,
    lat: 23.080986864639417,
    coordinateSystem: 'GCJ02',
    locationPending: false,
    // 展厅示意位置移入当前白鹤洞轮廓，原始安装坐标仍保留在 lng/lat。
    displayPosition: { lng: 113.2435, lat: 23.081, coordinateSystem: 'WGS84' },
    contacts: [
      {
        role: '场所联系人',
        name: '黄生',
        phone: '13602812460'
      },
      {
        role: '管理员',
        name: '白鹤洞街道',
        phone: '13560304386'
      }
    ]
  },
  {
    id: 'smoke-CB09730PDEA2484',
    serialNumber: 'CB09730PDEA2484',
    imei: '865176080771720',
    community: '山顶社区',
    room: '501',
    name: '广州市荔湾区白鹤洞街道山顶社区山顶一巷5号501房大厅',
    location: '广州市荔湾区白鹤洞街道山顶社区山顶一巷5号501房',
    place: '白鹤洞街道山顶社区山顶一巷5号501房',
    type: '感烟火灾探测器',
    model: 'DH-HY-SA1GA-A',
    connection: 'MQTT直连（烟感）',
    status: '正常',
    onlineStatus: '在线',
    battery: '100.0',
    signal: '中',
    arming: '布防',
    firstOnlineAt: '2026-07-13 15:57:20',
    lastOnlineAt: '2026-09-16 14:05:41',
    installedAt: '2026-07-13 15:52:46',
    lng: 113.25203017607983,
    lat: 23.08586510322954,
    coordinateSystem: 'GCJ02',
    locationPending: false,
    // 展厅示意位置移入当前白鹤洞轮廓，原始安装坐标仍保留在 lng/lat。
    displayPosition: { lng: 113.2455, lat: 23.0817, coordinateSystem: 'WGS84' },
    contacts: [
      {
        role: '场所联系人',
        name: '刘珍英',
        phone: '18312029902'
      },
      {
        role: '管理员',
        name: '白鹤洞街道',
        phone: '13560304386'
      }
    ]
  },
  {
    id: 'smoke-CB09730PDEA085C',
    serialNumber: 'CB09730PDEA085C',
    imei: '865176080428123',
    community: '鹤洞社区',
    room: '302',
    name: '广州市荔湾区白鹤洞街道鹤洞社区观鹤四巷6号302房大厅',
    location: '广州市荔湾区白鹤洞街道鹤洞社区观鹤四巷6号302房大厅',
    place: '白鹤洞街道鹤洞社区观鹤四巷6号302房',
    type: '感烟火灾探测器',
    model: 'DH-HY-SA1GA-A',
    connection: 'MQTT直连（烟感）',
    status: '正常',
    onlineStatus: '在线',
    battery: '100.0',
    signal: '弱',
    arming: '布防',
    firstOnlineAt: '2026-07-13 11:26:31',
    lastOnlineAt: '2026-09-17 03:48:39',
    installedAt: '2026-07-13 11:24:21',
    lng: 113.24892733938165,
    lat: 23.078189002376245,
    coordinateSystem: 'GCJ02',
    locationPending: false,
    contacts: [
      {
        role: '场所联系人',
        name: '蓝生',
        phone: '13710328313'
      },
      {
        role: '管理员',
        name: '白鹤洞街道',
        phone: '13560304386'
      }
    ]
  },
  {
    id: 'smoke-CB09730PDEA3C56',
    serialNumber: 'CB09730PDEA3C56',
    imei: '865176080741491',
    community: '金道社区',
    room: '204',
    name: '广州市荔湾区白鹤洞街道金道社区金通街2号204房大厅',
    location: '广州市荔湾区白鹤洞街道金道社区金通街2号204房大厅',
    place: '白鹤洞街道金道社区金通街2号204房',
    type: '感烟火灾探测器',
    model: 'DH-HY-SA1GA-A',
    connection: 'MQTT直连（烟感）',
    status: '正常',
    onlineStatus: '在线',
    battery: '100.0',
    signal: '中',
    arming: '布防',
    firstOnlineAt: '2026-07-13 10:47:41',
    lastOnlineAt: '2026-09-17 01:47:49',
    installedAt: '2026-07-13 10:45:35',
    lng: 113.2411325321994,
    lat: 23.077829329838433,
    coordinateSystem: 'GCJ02',
    locationPending: false,
    contacts: [
      {
        role: '场所联系人',
        name: '温锦泉',
        phone: '13434367916'
      },
      {
        role: '管理员',
        name: '白鹤洞街道',
        phone: '13560304386'
      }
    ]
  },
  {
    id: 'smoke-CB09730PDEA8C40',
    serialNumber: 'CB09730PDEA8C40',
    imei: '865176080949284',
    community: '金道社区',
    room: '402',
    name: '广州市荔湾区白鹤洞街道金道社区金达街17号402房大厅',
    location: '广州市荔湾区白鹤洞街道金道社区金达街17号402房大厅',
    place: '白鹤洞街道金道社区金达街17号402房',
    type: '感烟火灾探测器',
    model: 'DH-HY-SA1GA-A',
    connection: 'MQTT直连（烟感）',
    status: '正常',
    onlineStatus: '在线',
    battery: '100.0',
    signal: '弱',
    arming: '布防',
    firstOnlineAt: '2026-07-13 10:31:57',
    lastOnlineAt: '2026-09-16 15:45:12',
    installedAt: '2026-07-13 10:30:17',
    lng: 113.2411325321994,
    lat: 23.077829329838433,
    coordinateSystem: 'GCJ02',
    locationPending: false,
    contacts: [
      {
        role: '场所联系人',
        name: '梁焕珠',
        phone: '14654308591'
      },
      {
        role: '管理员',
        name: '白鹤洞街道',
        phone: '13560304386'
      }
    ]
  },
  {
    id: 'smoke-CB09730PDEA5D1B',
    serialNumber: 'CB09730PDEA5D1B',
    imei: '865176080456314',
    community: '金道社区',
    room: '104',
    name: '广州市荔湾区白鹤洞街道金道社区金通街19号104房大厅',
    location: '广州市荔湾区白鹤洞街道金道社区金通街19号104房',
    place: '白鹤洞街道金道社区金通街19号104房',
    type: '感烟火灾探测器',
    model: 'DH-HY-SA1GA-A',
    connection: 'MQTT直连（烟感）',
    status: '正常',
    onlineStatus: '在线',
    battery: '100.0',
    signal: '极差',
    arming: '布防',
    firstOnlineAt: '2026-07-13 10:16:35',
    lastOnlineAt: '2026-09-17 07:17:41',
    installedAt: '2026-07-13 10:14:12',
    lng: 113.2411325321994,
    lat: 23.077829329838433,
    coordinateSystem: 'GCJ02',
    locationPending: false,
    contacts: [
      {
        role: '场所联系人',
        name: '黄岳松',
        phone: '15202090034'
      },
      {
        role: '管理员',
        name: '白鹤洞街道',
        phone: '13560304386'
      }
    ]
  },
  {
    id: 'smoke-BL07CA5PDE160A8',
    serialNumber: 'BL07CA5PDE160A8',
    imei: '863555074783803',
    community: '观御社区',
    room: '1201',
    name: '白鹤洞街道观御社区C5栋1201房间门口',
    location: '白鹤洞街道观御社区C5栋1201房',
    place: '白鹤洞街道观御社区C5栋1201房',
    type: '感烟火灾探测器',
    model: 'DH-HY-SA1GA-A',
    connection: 'MQTT直连（烟感）',
    status: '正常',
    onlineStatus: '在线',
    battery: '100.0',
    signal: '强',
    arming: '布防',
    firstOnlineAt: '2026-02-11 06:40:00',
    lastOnlineAt: '2026-09-16 14:35:10',
    installedAt: '2026-01-04 10:28:32',
    lng: 113.24546,
    lat: 23.074908,
    coordinateSystem: 'GCJ02',
    locationPending: false,
    contacts: [
      {
        role: '场所联系人',
        name: '余蕴',
        phone: '13610153719'
      },
      {
        role: '管理员',
        name: '白鹤洞街道',
        phone: '13560304386'
      }
    ]
  },
  {
    id: 'smoke-BL07CA5PDE176C3',
    serialNumber: 'BL07CA5PDE176C3',
    imei: '863555074300988',
    community: '观御社区',
    room: '2303',
    name: '白鹤洞街道观御社区D2栋2303房大厅',
    location: '白鹤洞街道观御社区D2栋2303房',
    place: '白鹤洞街道观御社区D2栋2303房',
    type: '感烟火灾探测器',
    model: 'DH-HY-SA1GA-A',
    connection: 'MQTT直连（烟感）',
    status: '正常',
    onlineStatus: '在线',
    battery: '100.0',
    signal: '弱',
    arming: '布防',
    firstOnlineAt: '2026-02-10 21:00:08',
    lastOnlineAt: '2026-09-17 12:22:56',
    installedAt: '2026-01-04 14:47:20',
    lng: 113.24546,
    lat: 23.074908,
    coordinateSystem: 'GCJ02',
    locationPending: false,
    contacts: [
      {
        role: '场所联系人',
        name: '卓湘元',
        phone: '13902865335'
      },
      {
        role: '管理员',
        name: '白鹤洞街道',
        phone: '13560304386'
      },
      {
        role: '联系人2',
        name: '卓新元',
        phone: '18928901420'
      }
    ]
  },
  {
    id: 'smoke-BL07CA5PDE16431',
    serialNumber: 'BL07CA5PDE16431',
    imei: '863555074305565',
    community: '山顶社区',
    room: '401',
    name: '白鹤洞街道山顶社区鹤洞路三巷86号401房大厅',
    location: '白鹤洞街道山顶社区鹤洞路三巷86号401房',
    place: '白鹤洞街道山顶社区鹤洞路三巷86号401房',
    type: '感烟火灾探测器',
    model: 'DH-HY-SA1GA-A',
    connection: 'MQTT直连（烟感）',
    status: '正常',
    onlineStatus: '在线',
    battery: '100.0',
    signal: '中',
    arming: '布防',
    firstOnlineAt: '2026-02-10 18:21:05',
    lastOnlineAt: '2026-09-17 04:18:28',
    installedAt: '2025-12-31 15:14:24',
    lng: 113.242904,
    lat: 23.075453,
    coordinateSystem: 'GCJ02',
    locationPending: false,
    contacts: [
      {
        role: '场所联系人',
        name: '梁先生',
        phone: '18818801102'
      },
      {
        role: '管理员',
        name: '白鹤洞街道',
        phone: '13560304386'
      }
    ]
  },
  {
    id: 'smoke-BL07CA5PDE14E92',
    serialNumber: 'BL07CA5PDE14E92',
    imei: '863555075047471',
    community: '金道社区',
    room: '805',
    name: '白鹤洞街道金道社区金光大街29号805房大厅',
    location: '白鹤洞街道金道社区金光大街29号805房',
    place: '白鹤洞街道金道社区金光大街29号805房',
    type: '感烟火灾探测器',
    model: 'DH-HY-SA1GA-A',
    connection: 'MQTT直连（烟感）',
    status: '正常',
    onlineStatus: '在线',
    battery: '100.0',
    signal: '弱',
    arming: '布防',
    firstOnlineAt: '2026-02-10 14:56:24',
    lastOnlineAt: '2026-09-17 10:58:01',
    installedAt: '2025-12-29 15:29:52',
    lng: 113.240479,
    lat: 23.077168,
    coordinateSystem: 'GCJ02',
    locationPending: false,
    contacts: [
      {
        role: '场所联系人',
        name: '江伟洪',
        phone: '13724089303'
      },
      {
        role: '管理员',
        name: '白鹤洞街道',
        phone: '13560304386'
      }
    ]
  },
  {
    id: 'smoke-BL07CA5PDE16DC1',
    serialNumber: 'BL07CA5PDE16DC1',
    imei: '863555075474121',
    community: '山顶社区',
    room: '402',
    name: '白鹤洞街道山顶社区山顶一巷4号402房大厅',
    location: '白鹤洞街道山顶社区山顶一巷4号402房',
    place: '白鹤洞街道山顶社区山顶一巷4号402房',
    type: '感烟火灾探测器',
    model: 'DH-HY-SA1GA-A',
    connection: 'MQTT直连（烟感）',
    status: '正常',
    onlineStatus: '在线',
    battery: '100.0',
    signal: '极好',
    arming: '布防',
    firstOnlineAt: '2026-02-10 10:54:50',
    lastOnlineAt: '2026-09-17 00:58:01',
    installedAt: '2025-12-31 10:31:19',
    lng: 113.252624,
    lat: 23.085086,
    coordinateSystem: 'GCJ02',
    locationPending: false,
    // 展厅示意位置移入当前白鹤洞轮廓，原始安装坐标仍保留在 lng/lat。
    displayPosition: { lng: 113.2465, lat: 23.0807, coordinateSystem: 'WGS84' },
    contacts: [
      {
        role: '场所联系人',
        name: '林女士',
        phone: '13268320236'
      },
      {
        role: '管理员',
        name: '白鹤洞街道',
        phone: '13560304386'
      }
    ]
  },
  {
    id: 'smoke-BL07CA5PDE0F30E',
    serialNumber: 'BL07CA5PDE0F30E',
    imei: '863555075465541',
    community: '金道社区',
    room: '901',
    name: '白鹤洞街道金道社区金达街29号901房大厅',
    location: '白鹤洞街道金道社区金达街29号901房',
    place: '白鹤洞街道金道社区金达街29号901房',
    type: '感烟火灾探测器',
    model: 'DH-HY-SA1GA-A',
    connection: 'MQTT直连（烟感）',
    status: '正常',
    onlineStatus: '在线',
    battery: '100.0',
    signal: '中',
    arming: '布防',
    firstOnlineAt: '2026-02-11 07:25:51',
    lastOnlineAt: '2026-09-16 15:58:15',
    installedAt: '2025-12-29 15:51:37',
    lng: 113.234643,
    lat: 23.071887,
    coordinateSystem: 'GCJ02',
    locationPending: false,
    contacts: [
      {
        role: '场所联系人',
        name: '杨小姐',
        phone: '13510013341'
      },
      {
        role: '管理员',
        name: '白鹤洞街道',
        phone: '13560304386'
      }
    ]
  },
  {
    id: 'smoke-BL07CA5PDE0EA60',
    serialNumber: 'BL07CA5PDE0EA60',
    imei: '863555074302828',
    community: '金道社区',
    room: '602',
    name: '白鹤洞街道金道社区金达街41号602房大厅',
    location: '白鹤洞街道金道社区金达街41号602房',
    place: '白鹤洞街道金道社区金达街41号602房',
    type: '感烟火灾探测器',
    model: 'DH-HY-SA1GA-A',
    connection: 'MQTT直连（烟感）',
    status: '正常',
    onlineStatus: '在线',
    battery: '100.0',
    signal: '中',
    arming: '布防',
    firstOnlineAt: '2026-02-11 00:38:34',
    lastOnlineAt: '2026-09-16 14:30:25',
    installedAt: '2025-12-29 16:12:52',
    lng: 113.234643,
    lat: 23.071887,
    coordinateSystem: 'GCJ02',
    locationPending: false,
    contacts: [
      {
        role: '场所联系人',
        name: '赵丽娟',
        phone: '13802979466'
      },
      {
        role: '管理员',
        name: '白鹤洞街道',
        phone: '13560304386'
      }
    ]
  },
  {
    id: 'smoke-BL07CA5PDE15844',
    serialNumber: 'BL07CA5PDE15844',
    imei: '863555074095588',
    community: '山顶社区',
    room: '403',
    name: '白鹤洞街道山顶社区鹤洞路三巷86号403房大厅',
    location: '白鹤洞街道山顶社区鹤洞路三巷86号403房',
    place: '白鹤洞街道山顶社区鹤洞路三巷86号403房',
    type: '感烟火灾探测器',
    model: 'DH-HY-SA1GA-A',
    connection: 'MQTT直连（烟感）',
    status: '正常',
    onlineStatus: '在线',
    battery: '100.0',
    signal: '中',
    arming: '布防',
    firstOnlineAt: '2026-02-10 13:00:19',
    lastOnlineAt: '2026-09-16 22:08:36',
    installedAt: '2025-12-31 15:04:24',
    lng: 113.242904,
    lat: 23.075453,
    coordinateSystem: 'GCJ02',
    locationPending: false,
    contacts: [
      {
        role: '场所联系人',
        name: '梁女士',
        phone: '13719443634'
      },
      {
        role: '管理员',
        name: '白鹤洞街道',
        phone: '13560304386'
      }
    ]
  },
  {
    id: 'smoke-BL07CA5PDE15F1A',
    serialNumber: 'BL07CA5PDE15F1A',
    imei: '863555074015875',
    community: '金道社区',
    room: '605',
    name: '白鹤洞街道金道社区金光大街25号605房大厅',
    location: '白鹤洞街道金道社区金光大街25号605房',
    place: '白鹤洞街道金道社区金光大街25号605房',
    type: '感烟火灾探测器',
    model: 'DH-HY-SA1GA-A',
    connection: 'MQTT直连（烟感）',
    status: '正常',
    onlineStatus: '在线',
    battery: '100.0',
    signal: '中',
    arming: '布防',
    firstOnlineAt: '2026-02-11 07:40:51',
    lastOnlineAt: '2026-09-17 12:05:17',
    installedAt: '2025-12-29 15:10:26',
    lng: 113.240841,
    lat: 23.077189,
    coordinateSystem: 'GCJ02',
    locationPending: false,
    contacts: [
      {
        role: '场所联系人',
        name: '张远伯',
        phone: '13622741912'
      },
      {
        role: '管理员',
        name: '白鹤洞街道',
        phone: '13560304386'
      }
    ]
  },
  {
    id: 'smoke-BL07CA5PDE12536',
    serialNumber: 'BL07CA5PDE12536',
    imei: '863555074313536',
    community: '鹤园社区',
    room: '505',
    name: '荔湾区鹤园社区平西三巷3号505房大厅',
    location: '白鹤洞街道鹤园社区平西三巷3号505房',
    place: '白鹤洞街道鹤园社区平西三巷3号505房',
    type: '感烟火灾探测器',
    model: 'DH-HY-SA1GA-A',
    connection: 'MQTT直连（烟感）',
    status: '正常',
    onlineStatus: '在线',
    battery: '100.0',
    signal: '极好',
    arming: '布防',
    firstOnlineAt: '2026-02-11 07:11:54',
    lastOnlineAt: '2026-09-17 03:58:05',
    installedAt: '2025-12-25 14:34:44',
    lng: 113.244067,
    lat: 23.144877,
    coordinateSystem: 'GCJ02',
    locationPending: true,
    contacts: [
      {
        role: '场所联系人',
        name: '潘先生',
        phone: '13928840948'
      },
      {
        role: '管理员',
        name: '白鹤洞街道',
        phone: '13560304386'
      }
    ]
  }
];

export const smokeDevices = [
  ...apartmentDevices.map(device => ({
    ...device,
    community: smokeBuilding.name,
    place: smokeBuilding.sourceName,
    unitName: smokeBuilding.unitName,
    lng: smokeBuilding.lng,
    lat: smokeBuilding.lat,
    coordinateSystem: smokeBuilding.coordinateSystem,
    locationPending: false,
    pointId: smokeBuilding.id
  })),
  ...streetDevices.map(device => ({
    ...device,
    pointId: `smoke-${device.coordinateSystem}-${device.lng}-${device.lat}`
  }))
];

// 同来源、同坐标仅合并地图标记，不合并设备或将不同地址认定为同一建筑。
export function getSmokePoints (devices = smokeDevices) {
  const points = new Map();
  devices.filter(device => !device.locationPending).forEach(device => {
    if (!points.has(device.pointId)) {
      points.set(device.pointId, {
        id: device.pointId,
        name: device.pointId === smokeBuilding.id ? smokeBuilding.name
          : device.location.replace(/^广州市荔湾区|^荔湾区/, '').replace(/^白鹤洞街道/, '').replace(device.community, ''),
        lng: device.lng,
        lat: device.lat,
        coordinateSystem: device.coordinateSystem,
        // 只在地图输出时采用示意位置，点位分组和设备原始坐标保持不变。
        ...device.displayPosition,
        deviceCount: 0
      });
    }
    const point = points.get(device.pointId);
    point.deviceCount++;
    if (point.deviceCount > 1 && point.id !== smokeBuilding.id) point.name = `${device.community}共点设备`;
  });
  return [...points.values()];
}
